import './polyfills/findDOMNode';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
//import './style/global.css'
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './contexts/appContext';
import { createRoot } from 'react-dom/client';
/*const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);*/
const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) se estiver usando TypeScript

root.render(
  <React.StrictMode>
      <AppProvider>
          <BrowserRouter>
              <App />
          </BrowserRouter>
      </AppProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
